import * as yup from 'yup'
import { nameRegex } from '../../constants'

export const normalizeNameInput = (value: unknown) => {
  if (typeof value !== 'string') return ''
  return value
    .trim()
    .replace(/\s+/g, ' ')
    .normalize('NFC')
}

type NameFieldOptions = {
  label: string
  requiredMessage: string
  invalidMessage: string
  max?: number
}

export const createNameField = ({
  label,
  requiredMessage,
  invalidMessage,
  max = 50
}: NameFieldOptions) =>
  yup
    .string()
    .transform(normalizeNameInput)
    .required(requiredMessage)
    .max(max)
    .label(label)
    .matches(nameRegex, {
      message: invalidMessage,
      excludeEmptyString: true
    })

export const lastNameSchema = createNameField({
  label: 'Last name',
  requiredMessage: 'Please enter your last name',
  invalidMessage: 'Please enter a valid last name'
})

export const firstNameSchema = createNameField({
  label: 'First name',
  requiredMessage: 'Please enter your first name',
  invalidMessage: 'Please enter a valid first name'
})